import "./App.css";
import { useState, useEffect } from "react";

function App() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      window.location.replace("fb://page/262110883970960/");
      setUrl("fb://page/262110883970960/");
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      window.location.replace("fb://profile/262110883970960/");
      setUrl("fb://profile/262110883970960/");
    } else {
      window.location.replace("https://www.facebook.com/weddingnakhonnayok");
      setUrl("https://www.facebook.com/weddingnakhonnayok");
    }
  }, []);
  return (
    <div className="App">
      <p>กรุณารอซักครู่ กำลังนำท่านไปสู่เพจ สื่อรัก สตูดิโอ</p>
      <p>
        หรือ{" "}
        <a href={url}>
          <b>คลิกที่นี่</b>
        </a>{" "}
        เพื่อเข้าสู่เพจด้วยตนเอง
      </p>
    </div>
  );
}

export default App;
